export const heroSlides = [
  {
    title: 'Akustik Panel',
    brandSpan: 'Doku Akustik',
    isH1: true,
    subtitle: 'Profesyonel Çözümler & Estetik Tasarım',
    description:
      '2015’ten beri ofis, stüdyo ve yaşam alanları için akustik panel üretiyoruz. Yankı ve gürültüyü azaltan, mekâna uyumlu panelleri kendi tesisimizde üretip uyguluyoruz.',
    image: '/images/akustik-piramit-sunger-ses-yalitim.jpg.webp',
    imageAlt:
      'Akustik piramit sünger ses yalıtım paneli ile kaplanmış duvar uygulaması - Doku Akustik',
    circleImage: '/images/kumas-kapli-akustik-panel-2.jpg.webp',
    circleImageAlt:
      'Kumaş kaplı akustik panel yakın plan ürün görseli - Doku Akustik',
  },
  {
    title: 'Akustik Panel Ses Yalıtımı Uygulamaları',
    subtitle: 'Profesyonel Akustik Hizmeti',
    description:
      'Akustik panellerimizle 11 yılı aşkın tecrübemizle, projenize özel akustik ses yalıtımı ürünleri geliştiriyoruz. Alanında uzman ekibimiz profesyonel uygulama desteği sunmaktadır.',
    image: '/images/slider0.jpg.webp',
    imageAlt:
      'Profesyonel akustik panel ses yalıtımı uygulaması yapılan iç mekan - Doku Akustik',
    circleImage: '/images/akustik-difuzor.jpg.webp',
    circleImageAlt: 'Akustik difüzör panel ürün görseli - Doku Akustik',
  },
  {
    title: 'Toplantı Odası ve Çağrı Merkezi Ses Yalıtımı',
    subtitle: '',
    description:
      'Toplantı odaları ve çağrı merkezlerinde konuşma anlaşılırlığını artırıyor, dışarıya ses sızıntısını azaltıyoruz. Yoğun konuşma alanlarına özel akustik panel uygulamaları yapıyoruz.',
    image: '/images/duvar-ses-yalitimi.jpg1_.jpg.webp',
    imageAlt:
      'Toplantı odası duvar ses yalıtımı için akustik panel uygulaması - Doku Akustik',
    circleImage: '/images/3d-akustik-panel-main.webp',
    circleImageAlt: '3D akustik duvar paneli ürün görseli - Doku Akustik',
  },
  {
    title: 'Akustik Panel Üreticisi Doku Akustik',
    subtitle: '',
    description:
      'Yüksek performanslı akustik panel ve ses yalıtım sistemleri ile stüdyo, ofis ve yaşam alanlarında kontrol edilebilir akustik sunuyoruz.',
    image: '/images/Cagri-Merkezi-Ses-Yalitimi-1-1-1-1.jpg.webp',
    imageAlt:
      'Çağrı merkezi akustik panel ve ses yalıtımı uygulaması - Doku Akustik',
    circleImage: '/images/akustik-asma-tavan-panel-3.jpg.webp',
    circleImageAlt: 'Akustik asma tavan paneli uygulama görseli - Doku Akustik',
  },
] as const

export const products = [
  {
    name: 'Kumaş Kaplı Akustik Panel',
    slug: 'kumas-kapli-akustik-panel',
    href: '/urun/kumas-kapli-akustik-panel/',
    image: '/images/kumas-kapli-akustik-panel.webp',
    category: 'Akustik Paneller',
  },
  {
    name: 'Akustik Ahşap Panel',
    slug: 'akustik-ahsap-panel',
    href: '/urun/akustik-ahsap-panel/',
    image: '/images/akustik-ahsap-panel.webp',
    category: 'Akustik Paneller',
  },
  {
    name: 'Delikli Ahşap Panel',
    slug: 'delikli-ahsap-panel',
    href: '/urun/delikli-ahsap-panel/',
    image: '/images/ahsap-delikli-panel.webp',
    category: 'Akustik Paneller',
  },
  {
    name: '3D Akustik Panel',
    slug: '3d-akustik-panel',
    href: '/urun/3d-akustik-panel/',
    image: '/images/3d-akustik-panel-main.webp',
    category: 'Akustik Paneller',
  },
  {
    name: 'Akustik Keçe Panel',
    slug: 'akustik-kece-panel',
    href: '/urun/akustik-kece-panel/',
    image: '/images/akustik-kece-panel.webp',
    category: 'Akustik Paneller',
  },
  {
    name: 'Akustik Baffle Panel',
    slug: 'akustik-baffle-panel',
    href: '/urun/akustik-baffle-panel/',
    image: '/images/akustik-baffle-panel.webp',
    category: 'Akustik Paneller',
  },
  {
    name: 'Akustik Paravan',
    slug: 'akustik-paravan',
    href: '/urun/akustik-paravan/',
    image: '/images/akustik-paravan.webp',
    category: 'Akustik Paneller',
  },
  {
    name: 'Masa Seperatörü',
    slug: 'masa-seperatoru',
    href: '/urun/masa-seperatoru/',
    image: '/images/masa-seperatoru.webp',
    category: 'Akustik Paneller',
  },
] as const

export const productCategories = ['Akustik Paneller'] as const

export const services = [
  {
    title: 'Toplantı Odası Ses Yalıtımı',
    image: '/toplanti-odasi-ses-yalitimi.webp',
  },
  {
    title: 'Stüdyo Ses Yalıtımı',
    image: '/studyo-ses-yalitimi.webp',
  },
  {
    title: 'Ofis Ses Yalıtımı',
    image: '/ofis-akustigi-2_640x247.jpg.webp',
  },
  {
    title: 'Çağrı Merkezi Ses Yalıtımı',
    image: '/cagri-merkezi-ses-yalitimi.webp',
  },
  {
    title: 'Konferans Salonu Ses Yalıtımı',
    image: '/konferans-salonu-ses-yalitimi.webp',
  },
  {
    title: 'Duvar Ses Yalıtımı',
    image: '/duvar-ses-yalitimi.webp',
  },
] as const

export const whyUsProjects = [
  {
    title: 'İelev Okulları',
    description: 'Eğitim kurumlarında akustik konfor ve konuşma anlaşılırlığı.',
    image: '/images/konferans-salonu-ses-yalitimi.webp',
  },
  {
    title: 'Ford Otosan',
    description: 'Kurumsal ofis alanlarında gürültü kontrolü ve panel uygulamaları.',
    image: '/images/ofis-akustigi-2_640x247.jpg.webp',
  },
  {
    title: 'Zorlu Center',
    description: 'Ticari alanlarda estetik ve yüksek performanslı akustik paneller.',
    image: '/images/DUVAR-SES-YALITIMI-.jpg.webp',
  },
  {
    title: 'Koç Holding Çağrı Merkezi',
    description: 'Yoğun konuşma alanlarında ses yalıtım ve emilim çözümleri.',
    image: '/images/Cagri-Merkezi-Ses-Yalitimi-1-1-1-1.jpg.webp',
  },
  {
    title: 'Atatürk Havalimanı Vip Giriş',
    description: 'Prestij alanlarında sessizlik ve görsel bütünlük.',
    image: '/images/akustik-baffle-panel-2.jpg.webp',
  },
] as const

export const whyUsClients = [
  'İelev Okulları',
  'Ford Otosan',
  'Zorlu Center',
  'Koç Holding',
  'THY',
  'İş Bankası',
  'Garanti BBVA',
  'Vodafone',
  'Turkcell',
] as const

export const rotatingReasons = [
  '11 Yıllık Tecrübe',
  'Uygun Fiyat Politikası',
  'Zamanında Teslimat',
] as const

export const faqs = [
  {
    question: 'Doku Akustik akustik panel üretiminde hangi ürün gruplarını sunuyor?',
    answer:
      'Doku Akustik A.Ş olarak akustikpanel.tr üzerinden kumaş kaplı akustik panel, akustik ahşap panel, delikli ahşap panel, 3D akustik panel, akustik keçe panel, akustik baffle panel, akustik paravan ve masa seperatörü ürünlerini kendi tesisimizde üretiyoruz. Her ürün grubu farklı mekan ihtiyaçlarına göre konumlanır. Açık ofislerde konuşma mahremiyeti için kumaş kaplı paneller ve paravanlar, stüdyo ve sinema alanlarında yüksek soğurma için keçe veya 3D paneller, mimari duvar yüzeylerinde ise ahşap ve delikli ahşap paneller tercih edilir. Baffle paneller yüksek tavanlı alanlarda yankıyı yukarıdan kontrol eder. Masa seperatörleri ise çağrı merkezi ve open office masalarında kişi bazlı ses kontrolü sağlar. Ürün seçimini mekan tipi, tavan yüksekliği, kullanım süresi ve istenen NRC performansına göre birlikte planlıyoruz.',
  },
  {
    question: 'Akustik panel ile ses yalıtım paneli arasındaki fark nedir?',
    answer:
      'Akustik panel ve ses yalıtım paneli sıkça aynı ürün sanılır ama teknik olarak farklı işler yapar. Akustik panel, odanın içindeki yankıyı, çınlamayı ve reverberasyonu azaltır. Konuşmanın anlaşılırlığını yükseltir, ortam uğultusunu düşürür. Ses yalıtım paneli veya ses yalıtımlı panel yaklaşımı ise sesin duvardan, tavandan veya döşemeden bir mekandan diğerine geçmesini azaltmayı hedefler. Örneğin toplantı odasında yankı rahatsız ediyorsa akustik duvar paneli doğru çözümdür. Yan odadan konuşma sızıntısı varsa yalıtım ağırlıklı bir sistem gerekir. Doku Akustik projelerinde önce ses probleminin kaynağını ayırırız. Gerekirse yalnızca absorpsiyon panelleri, gerekirse yalıtım destekli bir kombinasyon öneririz. Böylece hem iç akustik hem mahremiyet hedefi tek seferde netleşir.',
  },
  {
    question: 'Hangi mekanlarda akustik duvar paneli kullanmak gerekir?',
    answer:
      'Akustik duvar paneli özellikle sert yüzeylerin baskın olduğu alanlarda gerekir. Cam, beton, fayans ve düz boyalı duvarlar sesi yansıtır. Bu yüzden açık ofisler, çağrı merkezleri, toplantı odaları, konferans salonları, stüdyolar, eğitim sınıfları, restoranlar ve ev ofislerinde yankı hızla artar. Doku Akustik uygulamalarında panelleri yalnızca dekoratif kaplama gibi değil, frekans ve kullanım senaryosuna göre konumlandırırız. Konuşma frekanslarının yoğun olduğu çağrı merkezinde kaplama oranı ve panel tipi farklıdır. Müzik stüdyosunda mid-high frekans kontrolü öne çıkar. Toplantı odasında ise konuşma netliği ve dışarıya sızıntının azaltılması birlikte ele alınır. Duvar paneli tek başına yetmezse baffle, tavan paneli veya paravan ile tamamlanır. Amaç mekânın günlük kullanımında gerçekten hissedilen bir akustik konfor elde etmektir.',
  },
  {
    question: 'Akustik panel fiyatları neye göre değişir?',
    answer:
      'Akustik panel fiyatları panel tipi, ölçü, kalınlık, yüzey kaplaması, yangın sınıfı, montaj yöntemi ve proje metrajına göre değişir. Kumaş kaplı panellerde kumaş kalitesi ve renk özel üretimi fiyatı etkiler. Ahşap ve delikli ahşap panellerde ahşap türü, delik deseni ve kaplama yüzeyi belirleyicidir. Keçe panellerde densite ve kalınlık, 3D panellerde form derinliği ve kalıp detayı maliyeti değiştirir. Baffle ve paravan sistemlerinde taşıyıcı konstrüksiyon ve montaj işçiliği de hesaba katılır. Toplu ofis veya çağrı merkezi projelerinde metrekare arttıkça birim maliyet avantajı oluşabilir. Güncel fiyat aralıkları ve ürün bazlı bilgilendirme için akustik panel fiyatları sayfamızı inceleyebilir veya showroom / fabrika üzerinden ölçüye özel teklif alabilirsiniz. Doku Akustik’te teklif, keşif sonrası fire ve montaj dahil netleşecek şekilde hazırlanır.',
  },
  {
    question: 'Kumaş kaplı akustik panel mi, akustik keçe panel mi seçmeliyim?',
    answer:
      'Seçim mekanın görsel dili ve teknik hedefine göre yapılır. Kumaş kaplı akustik panel ofis, otel, toplantı salonu ve yönetim katlarında yumuşak dokusu, geniş renk seçeneği ve premium görünümüyle öne çıkar. Kurumsal renklerle uyumlu yüzeyler üretilebilir, köşe ve çerçeve detayları mekâna özel çözülür. Akustik keçe panel ise daha grafik, modern ve hızlı montaj odaklıdır. Hexagon, dairesel veya özel kesimli keçe paneller duvarda güçlü bir tasarım dili kurar. NRC performansı her iki grupta da doğru kalınlık ve montaj boşluğuyla yükseltilir. Yoğun konuşma alanlarında kumaş kaplı paneller sık tercih edilirken, marka deneyimi ve duvar sanatı etkisi istenen lobilerde keçe paneller daha etkili olur. Doku Akustik ekibi her iki ürünü de aynı projede birlikte kullanarak hem performans hem estetik dengesi kurabilir.',
  },
  {
    question: 'Akustik ahşap panel ve delikli ahşap panel ne zaman tercih edilir?',
    answer:
      'Akustik ahşap panel ve delikli ahşap panel, ahşap yüzey estetiği istenen mimari projelerde tercih edilir. Otel lobileri, yönetim ofisleri, konferans salonları, sinema fuayeleri ve yüksek standartlı ticari alanlarda hem sıcak bir görünüm hem akustik soğurma sağlar. Delikli ahşap panelde delik çapı, delik aralığı ve arka absorpsiyon tabakası NRC değerini doğrudan etkiler. 1000, 2000 veya 4000 delik desenleri farklı frekans davranışları oluşturur. Düz ahşap görünümlü akustik panellerde ise görünür delik olmadan modern bir yüzey elde edilirken arkadaki akustik katman yankıyı kontrol eder. Nem ve yangın sınıfı gereksinimleri olan projelerde uygun kaplama ve taşıyıcı sistem seçilir. Doku Akustik, Dilovası tesisinde ölçüye özel üretim yaparak sahada fireyi azaltır ve montaj planını önceden netleştirir.',
  },
  {
    question: 'Montaj süreci nasıl işler ve keşif ücretsiz midir?',
    answer:
      'Süreç tipik olarak keşif, ölçüm, ürün seçimi, üretim, sevkiyat ve montaj adımlarından oluşur. Sancaktepe showroom’umuzda ürünleri yerinde görebilir, Dilovası fabrikamızda üretim kapasitesini ve malzeme detaylarını inceleyebilirsiniz. Proje alanına çıkıldığında tavan yüksekliği, duvar metrajı, mevcut yüzey durumu ve kullanım senaryosu not edilir. Ardından panel tipi, kaplama ve montaj detayı belirlenir. Üretim tamamlandıktan sonra paneller etiketlenmiş şekilde sahaya gelir. Montaj ekibimiz duvar hazırlığı, ankraj, hizalama ve son kontrolü yapar. Alan büyüklüğüne göre çoğu ofis ve stüdyo uygulaması birkaç gün içinde tamamlanır. Büyük çağrı merkezi veya çok katlı ofis projelerinde etaplı plan çıkarılır. Keşif ve ön değerlendirme için bizimle iletişime geçebilirsiniz. Amaç yalnızca ürün satmak değil, sahada çalışan bir akustik sonuç bırakmaktır.',
  },
  {
    question: 'Neden Doku Akustik’ten akustik panel almalıyım?',
    answer:
      'Doku Akustik A.Ş, 11 yılı aşkın süredir akustik panel ve ses yalıtım çözümleri üreten yerli bir üreticidir. Aracı stok ürünü değil, projenize göre üretilmiş paneller sunarız. Yerli üretim sayesinde ölçü, renk, yangın sınıfı ve montaj detayında hızlı revizyon yapabiliriz. NRC odaklı ürün tasarımı, A2-s1,d0 gibi yanmazlık hedeflerine uygun üretim yaklaşımı ve estetik kaplama seçenekleri aynı çatı altında ilerler. Showroom ve fabrika adreslerimiz şeffaftır. Telefon, WhatsApp ve e-posta üzerinden proje danışmanlığı alabilirsiniz. akustikpanel.tr üzerinden ürün sayfalarını inceleyip doğrudan ihtiyaç duyduğunuz panel tipine ulaşabilirsiniz. Uzun vadede bakıldığında doğru ürün + doğru montaj, sonradan yapılan yetersiz uygulamalardan hem daha sessiz hem daha ekonomik sonuç verir.',
  },
] as const

export const blogCards = [
  {
    title: 'Akustik Panel Nedir? Nerelerde Kullanılır?',
    excerpt: 'Akustik panel seçimi, mekan tipi ve ses hedefine göre nasıl yapılmalı?',
    href: '/akustik-panel/',
    image: '/images/akustik-panel.webp',
  },
  {
    title: 'Akustik Panel Fiyatları 2026',
    excerpt: 'Kumaş, keçe ve ahşap panellerde fiyatı etkileyen başlıca faktörler.',
    href: '/akustik-panel-fiyatlari/',
    image: '/images/kumas-kapli-akustik-panel.webp',
  },
  {
    title: 'Kumaş Kaplı Akustik Panel Avantajları',
    excerpt: 'Estetik görünüm ve yüksek ses emilimini bir arada sunan panel tipi.',
    href: '/urun/kumas-kapli-akustik-panel/',
    image: '/images/kumas-kapli-akustik-panel-2.jpg.webp',
  },
  {
    title: 'Akustik Keçe Panel Çözümleri',
    excerpt: 'PET felt paneller ile ofis ve ortak alanlarda modern akustik.',
    href: '/urun/akustik-kece-panel/',
    image: '/images/akustik-kece-panel.webp',
  },
] as const

export const aboutStats = [
  { value: 2895, suffix: '+', label: 'MUTLU MÜŞTERİ' },
  { value: 1000, suffix: '+', label: 'AKUSTIK PANEL ÜRETİMİ' },
  { value: 2000, suffix: '+', label: 'SES YALITIM İŞLEMİ' },
] as const

export { seoHtml } from '@/data/homepage-seo'
